import { useContext } from 'react';
import { SnackbarContext } from '../context/snackbar-context';

export const useSnackbar = () => useContext(SnackbarContext);
